import cn from 'classnames'
import s from 'pages/common.module.scss'
import { Button } from 'react-bootstrap'
import { getTooltip, Tooltip } from 'utils/tooltipLibrary'
import pluralizer from 'utils/pluralizer'
import { Status as StatusParcelle } from 'redux/features/parcelle/slice'
import { makeSelectParcelles } from 'redux/features/parcelle/selectors'
import { useAppSelector } from 'redux/hooks'
import useBienAVendre from 'hooks/useBienAVendre'
import TooltipBadge from 'components/TooltipBadge/TooltipBadge'
import ButtonArrow from 'components/ButtonArrow'
import Synthese from 'pages/BiensAVendre/components/Synthese/Synthese'

const googleTagNavigation =
  process.env.REACT_APP_GOOGLE_TAG_NAVIGATION_BIEN_A_VENDRE ?? ''

const ActionsResultatSection = (): JSX.Element | null => {
  const {
    locations,
    typeBien,
    surfaceHabitable,
    surfaceTerrainMin,
    surfaceTerrainMax,
    surfaceAuSolMin,
    surfaceAuSolMax,
    etages,
    piscine,
    setSurfaceAuSolMin,
    setSurfaceAuSolMax,
    setSurfaceTerrainMin,
    setSurfaceTerrainMax,
    onSubmitForm,
    statusParcelle,
    nextParcelle,
    previousParcelle,
    isNextAvailable,
    isPreviousAvailable,
    onEditClick,
    onNouveauCiblageClick,
  } = useBienAVendre()

  const parcelles = useAppSelector(makeSelectParcelles)

  return (
    <>
      <div className={s.syntheseControls}>
        <Button
          variant="link"
          className={cn(s.btn, s.underline)}
          onClick={onEditClick}
        >
          Modifier
        </Button>
        <Button
          variant="link"
          className={cn(s.btn, s.underline)}
          onClick={onNouveauCiblageClick}
        >
          Nouveau ciblage
        </Button>
      </div>
      <Synthese
        locations={locations}
        typeBien={typeBien !== null ? [typeBien] : null}
        surfaceHabitable={surfaceHabitable}
        surfaceTerrainMin={surfaceTerrainMin}
        surfaceTerrainMax={surfaceTerrainMax}
        surfaceAuSolMin={surfaceAuSolMin}
        surfaceAuSolMax={surfaceAuSolMax}
        etages={etages}
        piscine={piscine}
        setSurfaceAuSolMin={setSurfaceAuSolMin}
        setSurfaceAuSolMax={setSurfaceAuSolMax}
        setSurfaceTerrainMin={setSurfaceTerrainMin}
        setSurfaceTerrainMax={setSurfaceTerrainMax}
        tooltipSurfaceAuSol={getTooltip(Tooltip.EmpriseAuSol)}
        tooltipsurfaceTerrain={getTooltip(Tooltip.SurfaceTerrain)}
        submitForm={onSubmitForm}
      />
      {statusParcelle === StatusParcelle.ShowParcelleResults && (
        <div className={s.resultAndNavigation}>
          <div className={s.resultCount}>
            <p>
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: pluralizer(
                    [
                      '<b>Aucun résultat</b> à explorer',
                      '<b>{{count}} résultat</b> à explorer',
                      '<b>{{count}} résultats</b> à explorer',
                    ],
                    parcelles.length
                  ),
                }}
              />
              <TooltipBadge
                className={s.badge}
                label="resultats"
                tooltip={getTooltip(Tooltip.ResultatsCiblerBiens)}
              />
            </p>
            {!!parcelles.length && (
              <p>Visitez ces biens grâce aux boutons ci-dessous :</p>
            )}
          </div>
          {parcelles.length > 1 && (
            <div className={s.resultNavigation}>
              <ButtonArrow
                size="xs"
                className={cn(s.arrowLeft, googleTagNavigation)}
                direction="left"
                onClick={previousParcelle}
                disabled={!isPreviousAvailable}
                label={{
                  text: 'Précédent',
                  position: 'after',
                }}
              />
              <ButtonArrow
                size="xs"
                className={cn(s.arrowRight, googleTagNavigation)}
                direction="right"
                onClick={nextParcelle}
                disabled={!isNextAvailable}
                label={{
                  text: 'Suivant',
                  position: 'before',
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default ActionsResultatSection
